import { createSelector } from 'reselect';
const selectRaw = (state) => state.navigateManageReducer;

const menuNavigate = createSelector(
    [selectRaw],
    (navigateManageReducer) => navigateManageReducer.memu,
);

const NavigateManageSelector = {
    selectRaw,
    menuNavigate
}
export default NavigateManageSelector;